
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game-changer-awards",
      function () {
        return require("private-next-pages/game-changer-awards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game-changer-awards"])
      });
    }
  